import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Row, Col, Container } from "react-bootstrap";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  const card = (
    <>
      <ThemeProvider theme={theme}>
        <CardContent>
          <Typography
            gutterBottom
            sx={{ color: "text.secondary", fontSize: 14 }}
          >
            Polski Związek Inżynierów i Techników Budownictwa - ODDZIAŁ KATOWICE
          </Typography>
          {userData && ["1", "3"].includes(userData.permId) && (
            <Row style={{ marginBottom }}>
              <Col style={{ marginBottom }}>
                <Typography variant="h6" component="div">
                  {bull} Lista wykonawców
                </Typography>
                <Typography variant="body2">
                  Możliwość dodania Wykonawcy wraz z jego edycją. Wyszukiwanie
                  Wykonawców wg podanych kryteriów.
                </Typography>
              </Col>
              <Col style={{ marginBottom }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/performers")}
                >
                  Przejdź do listy
                </Button>
              </Col>
            </Row>
          )}
          {userData && (userData.permId === "1" || userData.permId === "3") && (
            <Row style={{ marginBottom }}>
              <Col style={{ marginBottom }}>
                <Typography variant="h6" component="div">
                  {bull} Osoby uprawnione
                </Typography>
                <Typography variant="body2">
                  Możliwość dodania Pracownika Wewnętrznego wraz z uprawnieniami
                  do Systemu. Wyszukiwanie
                </Typography>
              </Col>
              <Col style={{ marginBottom }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/internalUsers")}
                >
                  Przejdź do listy
                </Button>
              </Col>
            </Row>
          )}
          <Row style={{ marginBottom }}>
            <Col style={{ marginBottom }}>
              <Typography variant="h6" component="div">
                {bull} Zlecenia
              </Typography>
              <Typography variant="body2">Informacje o zleceniach.</Typography>
            </Col>
            <Col style={{ marginBottom }}>
              <Button variant="outlined" onClick={() => navigate("/tasks")}>
                Przejdź do listy
              </Button>
            </Col>
          </Row>
          {userData && ["1", "3"].includes(userData.permId) && (
            <Row style={{ marginBottom }}>
              <Col style={{ marginBottom }}>
                <Typography variant="h6" component="div">
                  {bull} Opis działania aplikacji
                </Typography>
              </Col>
              <Col style={{ marginBottom }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/appdescription")}
                >
                  Przejdź do opisu
                </Button>
              </Col>
            </Row>
          )}
        </CardContent>
      </ThemeProvider>
    </>
  );

  return (
    <div>
      <VN userData={userData} />
      <Container>
        <Box sx={{ maxWidth: 600 }}>
          <Card variant="outlined">{card}</Card>
        </Box>
      </Container>
    </div>
  );
}
